
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"50%","y1":"99.709%","x2":"50%","y2":".777%","id":"linearGradient-1"}},[_c('stop',{attrs:{"stop-color":"#E09B3D","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#C74C4D","offset":"30%"}}),_c('stop',{attrs:{"stop-color":"#C21975","offset":"60%"}}),_c('stop',{attrs:{"stop-color":"#7024C4","offset":"100%"}})])]),_c('g',{attrs:{"id":"icon/ic_instabook","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M7.5 0C11.642 0 15 3.372 15 7.53c0 .157-.005.315-.014.47h-2.264a4.7 4.7 0 00-2.453.686l.218-1.689H8.412V5.655c0-.61.168-1.024 1.038-1.024h1.109V2.747a14.87 14.87 0 00-1.615-.082c-1.6 0-2.695.98-2.695 2.781V7H4.44v2.104h1.81v5.847A7.517 7.517 0 010 7.53C0 3.372 3.358 0 7.5 0zm2.19 9.102a4.737 4.737 0 00-1.279 1.69l.001-1.69z","id":"Combined-Shape","fill":"#0075FB","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M19.531 9A4.474 4.474 0 0124 13.469v6.062A4.474 4.474 0 0119.531 24H13.47A4.474 4.474 0 019 19.531V13.47A4.474 4.474 0 0113.469 9zm0 1.509H13.47a2.96 2.96 0 00-2.96 2.96v6.062a2.96 2.96 0 002.96 2.96h6.062a2.96 2.96 0 002.96-2.96V13.47a2.96 2.96 0 00-2.96-2.96zM16.5 12.75a3.754 3.754 0 013.75 3.75 3.754 3.754 0 01-3.75 3.75 3.754 3.754 0 01-3.75-3.75 3.754 3.754 0 013.75-3.75zm0 1.459a2.291 2.291 0 100 4.582 2.291 2.291 0 000-4.582zm4.219-2.396a.469.469 0 110 .937.469.469 0 010-.938z","id":"Combined-Shape","fill":"#8021b4"}})])])
          )
        }
      }
    